<p-menubar *ngIf="!hidden && type != 'Side'" [model]="menus" [class]="hostClasses" [styleClass]="verticalClass">
</p-menubar>

<p-tieredMenu *ngIf="!hidden && type == 'Side'" [model]="menus" [class]="hostClasses" [styleClass]="verticalClass">
</p-tieredMenu>

<zappIcon *ngIf="!notCollapsible && type == 'Side'" themeIcon="bars" [circularBackground]="false" (click)="toggleMenu()" class="toggle">
</zappIcon>
